import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=33cddf0f&"
import script from "./Extras.vue?vue&type=script&lang=ts&"
export * from "./Extras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports